import {Directive, ElementRef, EventEmitter, HostListener, Input, Output} from '@angular/core';
import {keyboardKeys} from '../constants/keyboard-keys.constants';

@Directive({
  selector: '[siClickOutsideClose]'
})
export class ClickOutsideCloseDirective {
  @Input() siClickOutsideClose: boolean;
  @Input() siClickOutsideInactive: boolean;
  @Input() siClickOutsideCloseButton: string;
  @Output() siClickOutsideCloseChange = new EventEmitter<boolean>();

  constructor(private el: ElementRef) { }

  @HostListener('body:click', ['$event'])
  clickOutside(event: Event): void {
    if (this.el.nativeElement.contains(event.target)) {
      return;
    }

    if (this.siClickOutsideCloseButton) {
      const parentWithClass = (event.target as Element).closest(`.${this.siClickOutsideCloseButton}`);
      if (parentWithClass) {
        return;
      }
    }

    this.close();
  }

  @HostListener('window:blur')
  onBlur(): void {
    this.close();
  }

  @HostListener('window:hashchange', ['$event'])
  onHashChange(): void {
    this.close();
  }

  @HostListener('body:keyup', ['$event'])
  keyEvent(event: KeyboardEvent): void {
    if (event.key === keyboardKeys.ESC) {
      this.close();
    }
  }

  close(): void {
    if (this.siClickOutsideInactive) {
      return;
    }

    this.siClickOutsideCloseChange.emit(false);
  }

}
